import { ErrorCode } from 'dygc'
import { createPopup } from '@/assets/js/factory'
import OverlayTip from '@/components/overlay/OverlayTip'
import OverlayQrCode from '@/components/overlay/OverlayQrCode'
import OverlayPassword from '@/components/overlay/OverlayPassword'
import OverlayOnlyWeixin from '@/components/overlay/OverlayOnlyWeixin'
import Breakpoint from '@/components/overlay/Breakpoint'
import OverlayRestart from '@/components/overlay/OverlayRestart'
import MessageBox from '@/components/overlay/ErrorMessageBox.vue'
import AgreeInfo from '@/components/overlay/AgreeInfo.vue'

const map = new WeakMap()

export function overlay({ code, message, data }) {
  let vm = null
  if (code === ErrorCode.FansNormal) {
    vm =  createPopup(OverlayTip, {
      text: message
    })
  } else if (code === ErrorCode.FansQr) {
    vm =  createPopup(OverlayQrCode, {
      url: data,
      text: message
    })
  } else if (code === ErrorCode.PASSWORD) {
    vm = map.get(OverlayPassword)
    if (!vm) {
      vm = createPopup(OverlayPassword)
      vm.$on('close', () => {
        map.delete(OverlayPassword)
      })
    }
    vm.onUpdate(message, data)
    map.set(OverlayPassword, vm)
    return vm
  } else if (code === ErrorCode.ONLY_WEIXIN) {
    vm =  createPopup(OverlayOnlyWeixin)
  } else if (code === ErrorCode.BREAKPOINT) {
    vm =  createPopup(Breakpoint, { data })
  } else if (code === ErrorCode.RESTART) {
    vm =  createPopup(OverlayRestart)
  } else if (code === ErrorCode.ERROR_MESSAGE_OVERLAY) {
    vm =  createPopup(MessageBox, { data })
  } else if (code === ErrorCode.AGREE_INFO) {
    vm =  createPopup(AgreeInfo, { option: data })
  }
  return vm
}
